(function ($) {
    function new_map($el) {
        var $markers = $el.find('.marker');

        var args = {
            zoom: 16,
            center: new google.maps.LatLng(0, 300),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    featureType: 'administrative',
                    elementType: 'all',
                    stylers: [
                        {
                            hue: '#000000'
                        },
                        {
                            lightness: -100
                        },
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'administrative.locality',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'on'
                        },
                        {
                            saturation: '-3'
                        },
                        {
                            gamma: '1.81'
                        },
                        {
                            weight: '0.01'
                        },
                        {
                            hue: '#ff0000'
                        },
                        {
                            lightness: '17'
                        }
                    ]
                },
                {
                    featureType: 'administrative.land_parcel',
                    elementType: 'all',
                    stylers: [
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'landscape',
                    elementType: 'geometry',
                    stylers: [
                        {
                            hue: '#dddddd'
                        },
                        {
                            saturation: -100
                        },
                        {
                            lightness: -3
                        },
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'landscape',
                    elementType: 'labels',
                    stylers: [
                        {
                            hue: '#000000'
                        },
                        {
                            saturation: -100
                        },
                        {
                            lightness: -100
                        },
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'poi',
                    elementType: 'all',
                    stylers: [
                        {
                            hue: '#000000'
                        },
                        {
                            saturation: -100
                        },
                        {
                            lightness: -100
                        },
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'geometry',
                    stylers: [
                        {
                            hue: '#bbbbbb'
                        },
                        {
                            saturation: -100
                        },
                        {
                            lightness: 26
                        },
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'road',
                    elementType: 'labels',
                    stylers: [
                        {
                            hue: '#ffffff'
                        },
                        {
                            saturation: -100
                        },
                        {
                            lightness: 100
                        },
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.text',
                    stylers: [
                        {
                            visibility: 'on'
                        },
                        {
                            color: '#797979'
                        }
                    ]
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#868686'
                        }
                    ]
                },
                {
                    featureType: 'road.arterial',
                    elementType: 'labels.text.stroke',
                    stylers: [
                        {
                            color: '#ffffff'
                        }
                    ]
                },
                {
                    featureType: 'road.local',
                    elementType: 'all',
                    stylers: [
                        {
                            hue: '#ff0000'
                        },
                        {
                            saturation: -100
                        },
                        {
                            lightness: 100
                        },
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'road.local',
                    elementType: 'labels.text',
                    stylers: [
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'road.local',
                    elementType: 'labels.text.fill',
                    stylers: [
                        {
                            color: '#b6b2b2'
                        }
                    ]
                },
                {
                    featureType: 'transit',
                    elementType: 'labels',
                    stylers: [
                        {
                            hue: '#ff0000'
                        },
                        {
                            lightness: -100
                        },
                        {
                            visibility: 'off'
                        }
                    ]
                },
                {
                    featureType: 'water',
                    elementType: 'geometry',
                    stylers: [
                        {
                            hue: '#ff0000'
                        },
                        {
                            saturation: -100
                        },
                        {
                            lightness: 100
                        },
                        {
                            visibility: 'on'
                        }
                    ]
                },
                {
                    featureType: 'water',
                    elementType: 'labels',
                    stylers: [
                        {
                            hue: '#000000'
                        },
                        {
                            saturation: -100
                        },
                        {
                            lightness: -100
                        },
                        {
                            visibility: 'off'
                        }
                    ]
                }
            ]
        };

        var map = new google.maps.Map($el[0], args);

        map.markers = [];

        $markers.each(function () {
            add_marker($(this), map);
        });

        center_map(map);

        google.maps.event.addListener(map, 'click', function (event) {
            $.closeAllInfoWindowPlaces();
        });

        return map;
    }

    function add_marker($marker, map) {
        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
        var markerLabel = $marker.attr('data-label');
        var iconUrl = localize.themeurl + '/assets/img/svg/map_pin.svg';

        if ($marker.attr('data-places') == '1') {
            iconUrl = localize.themeurl + '/assets/img/svg/pin_places.svg';
        }

        var iconActiveUrl = localize.themeurl + '/assets/img/svg/pin_places_active.svg';
        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: {
                url: iconUrl,
                scaledSize: new google.maps.Size(36, 48),
                labelOrigin: new google.maps.Point(78, 20)
            }
        });

        map.markers.push(marker);

        // If marker contains HTML, add it to an infoWindow.
        if ($marker.html()) {
            // Create info window.
            marker['infowindow'] = new google.maps.InfoWindow({
                content: $marker.html()
            });

            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function () {
                if (currentmarkerplaces != this) {
                    marker.setIcon(iconActiveUrl);

                    $.closeAllInfoWindowPlaces();

                    currentinfowindowplaces = this['infowindow'];
                    currentmarkerplaces = this;
                    currentinfowindowplaces.open(map, this);
                    //map.setCenter(this.getPosition());
                    removeDefaultInfowindow();
                }
            });
        }
    }

    //Removing default infoWindow styles
    function removeDefaultInfowindow() {
        $('.gm-style-iw')
            .next()
            .css({ height: '0px' }); //remove arrow bottom inforwindow
        $('.gm-style-iw')
            .prev()
            .html(''); //remove style default inforwindows
        $('.gm-style-iw')
            .parent()
            .css('pointer-events', 'none');
    }

    $.closeAllInfoWindowPlaces = function closeAllInfoWindowPlaces() {
        if (currentinfowindowplaces) {
            currentinfowindowplaces.close();
            currentinfowindowplaces = null;
        }
        if (currentmarkerplaces) {
            currentmarkerplaces.setIcon({
                url: localize.themeurl + '/assets/img/svg/pin_places.svg',
                scaledSize: new google.maps.Size(36, 48),
                labelOrigin: new google.maps.Point(78, 20)
            });
            currentmarkerplaces = null;
        }
    };

    $(document).on('click', '.js-close-infowindow', function (e) {
        e.preventDefault();
        $.closeAllInfoWindowPlaces();
    });

    function center_map(map) {
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else {
            // fit to bounds
            map.fitBounds(bounds);
        }

        map.panBy(0, -58);
    }

    var map = null;
    var currentinfowindowplaces = null;
    var currentmarkerplaces = null;

    $(function () {
        $('.js-simple-map').each(function () {
            map = new_map($(this));
        });
    });
})(jQuery);
